import type { WithdrawDetail } from '../../../types/recommendation.types'
import { StepHeading } from '../../../components/plan/StepHeading'
import { DeadlineCallout } from '../../../components/plan/DeadlineCallout'
import { FolioList } from '../../../components/plan/FolioList'
import { HarvestingPlanType } from '../../../types/summary.types'

type FolioWithdrawSectionProps = {
  stepNumber: number
  title: string
  withdrawDetails: WithdrawDetail[]
  harvestType: HarvestingPlanType
  isFutureTax: boolean
  isGains: boolean
}

export function FolioWithdrawSection({
  stepNumber,
  title,
  withdrawDetails,
  harvestType,
  isFutureTax,
  isGains,
}: FolioWithdrawSectionProps) {
  return (
    <div className="flex flex-col">
      <StepHeading stepNumber={stepNumber} title={title} />
      <div className='pt-2 pb-6 w-[90%]'>
        <DeadlineCallout
          message={`Withdraw before 30th Mar, 12:00 PM to avail your tax benefit before financial year ends`}
        />
      </div>
      <FolioList
        withdrawDetails={withdrawDetails}
        harvestType={harvestType}
        isFutureTax={isFutureTax}
        isGains={isGains}
      />
    </div>
  )
}
